import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { CNDomain } from '../models/cndomain';
import { CNUser } from '../models/cnuser';
import { BCAgenda } from '../models/custom/bcagenda';
import { SNAgendaAppointment } from '../models/snagendaappointment';
import { SNDomain } from '../models/sndomain';
import { SNUser } from '../models/snuser';
import { BecareService } from './becare.service';
import * as moment from 'moment';
import { SNAgenda } from '../models/snagenda';
import { SNItemFactory } from '../models/snitemfactory';

export class BCAgendaResult {
  success: boolean;
  agendas: BCAgenda[];
}

@Injectable({
  providedIn: 'root'
})
export class AgendaService {

  public agendas: BCAgenda[] = [];
  private agendasData$: Observable<BCAgendaResult>;

  constructor(private becare: BecareService) {
    this.agendasData$ = this.becare.call('/fr/agenda/groups/agendas').pipe(
      shareReplay(1)
    );
  }

  public loadAgendas() {
    this.agendasData$.subscribe(agendas => {
      const agendaResult = agendas as BCAgendaResult;
      if (agendaResult.success) {
        this.agendas = agendaResult.agendas;
      }
    });
  }

  public openingHours(agenda: BCAgenda, year: number, month: number) {
    this.becare.call('/fr/agenda/' + agenda.agendaid + '/openinghour/' + year.toString() + '/' + month.toString()).subscribe(result => {
      console.log(result);
    });
  }

  addAppointment() {
    console.log('addAppointment');
  }

  public userAgenda(user: CNUser): Observable<SNAgenda> {
    return new Observable(observer => {
      this.becare.call('/fr/agenda/user/' + user.id).subscribe(result => {
        if (result.success === true && result.agenda !== undefined) {
          const factory = new SNItemFactory();
          const agenda = factory.itemFromJson(result.agenda);
          observer.next(agenda);
        }
      });
    });
  }

  public userAppointments(user: CNUser, domain: SNDomain | CNDomain | string,
                          date: string | Date, filter?: [string, string][]): Observable<SNAgendaAppointment[]> {
    return new Observable(observer => {
      const domainid: string = (typeof domain === 'string') ? domain : domain.id.toString();
      const datestring = (typeof date === 'string') ? date : moment(date).format('DD/MM/YYYY');
      let query: [string, string][] = [['date', datestring]];
      if (filter) {
        query = query.concat(filter);
      }
      this.becare.call('/fr/agenda/group/all/user/' + user.id + '/appointment', query).subscribe(result => {
        console.log('user appointments', result);
        observer.next(result.appointments);
      });
    });
  }

  public groupAgenda(groupid: string): SNAgenda {
    return undefined;
  }

  public currentAgenda(): Observable<SNAgenda> {
    return new Observable(observer => {
      this.becare.call('/fr/agenda/user/group/current', undefined, undefined, undefined, 'agenda', true).subscribe(agenda => {
        observer.next(agenda);
      });
    });
  }
}
